import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

export default {
    name: 'SurveyItemsAggregation',
    productArea: PRODUCT_AREAS.SURVEYS,
    subProductArea: SUB_PRODUCT_AREAS.GENERAL,
    responseFormat: 'rows',
    build: ({ surveyItemIds }: { surveyItemIds: string[] }) => {
        return o.pipeline(
            o.spawn(
                o.pipeline(
                    o.sources.surveyItems({ surveyItemIds }),
                    o.filter('len(surveyAnswerIds) != 0'),
                    o.unwind('surveyAnswerIds', { index: 'surveyAnswersIndex', keepEmpty: false, prefix: false }),
                    o.evaluate({
                        'surveyAnswer.id': 'surveyAnswerIds',
                        'surveyAnswer.description': 'surveyAnswerDescriptions[surveyAnswersIndex]',
                        'surveyAnswer.text': 'surveyAnswerDisplayTexts[surveyAnswersIndex]',
                        'surveyAnswer.value': 'surveyAnswerAnalyticalValues[surveyAnswersIndex]',
                    }),
                    o.group(
                        ['id', 'surveyItemText', 'surveyItemType'],
                        o.groupField('surveyAnswers', o.list('surveyAnswer')),
                    ),
                    o.select({
                        id: 'id',
                        type: 'surveyItemType',
                        answers: 'surveyAnswers',
                        questionText: 'surveyItemText',
                        displayAttributes: 'displayAttributes',
                    }),
                ),
                o.pipeline(
                    o.sources.surveyItems({ surveyItemIds }),
                    o.filter('len(surveyAnswerIds) == 0'),
                    o.select({
                        id: 'id',
                        type: 'surveyItemType',
                        answers: 'surveyAnswers',
                        questionText: 'surveyItemText',
                        displayAttributes: 'displayAttributes',
                    }),
                ),
            ),
        );
    },
};
